import { html, nothing, TemplateResult } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { DisplayMode } from '@api-consent/schema/Enums.js';
import type { TefComs4csMicroFrontend } from '@src/components/tef-coms4cs.js';
import { replaceElementsBound } from '@src/components/templates/util.js';

export function mainTemplate(this: TefComs4csMicroFrontend): TemplateResult {
  const historyTemplate = this.getTemplateFn('historyTemplate');
  const groupTemplate = this.getTemplateFn('groupTemplate');
  const groupTemplateOverview = this.getTemplateFn('groupTemplateOverview');
  const referencesTemplate = this.getTemplateFn('referencesTemplate');

  let content;
  if (this.store.history?.configId) {
    content = historyTemplate();
  } else {
    content = this.displayConsentGroups?.filter((group) => group.displayMode !== DisplayMode.HIDDEN)
      .map((group) => (this.mode === 'overview'
        ? groupTemplateOverview(group)
        : groupTemplate(group)));
  }

  return html`
    <one-stack name="main">
      ${this.showReferences ? referencesTemplate(this.store.references) : nothing}
      ${content}

      ${((this.displayConsentGroups?.length ?? 0) > 0 && this.store.details?.pageFooter)
    ? html`<p>${unsafeHTML(replaceElementsBound(this, this.store.details.pageFooter))}</p>`
    : nothing}
    </one-stack>
  `;
}
